import { Capacitor } from "@capacitor/core";
import { getApiUrl } from "@/lib/api-url";
import { getNativeSessionToken } from "@/lib/auth-client";
import { SUPPORT_SESSION } from "@/lib/support-session";

/**
 * fetch to the API with auth: cookies on web, Bearer on native and in a
 * support tab (lib/support-session.ts). A caller that
 * names `credentials` keeps them: the connect pages send "omit", because their
 * origin may not hold a session (connect/origins.ts).
 */
export function apiFetch(path: string, init?: RequestInit): Promise<Response> {
  return apiFetchUrl(getApiUrl(path), init);
}

/** Same as {@link apiFetch} but matches `fetch` (for `DefaultChatTransport`). */
export async function apiFetchUrl(
  input: RequestInfo | URL,
  init?: RequestInit
): Promise<Response> {
  const isNative = Capacitor.isNativePlatform();
  const bearerOnly = isNative || SUPPORT_SESSION !== null;
  const token =
    SUPPORT_SESSION?.token ?? (isNative ? await getNativeSessionToken() : null);
  const headers = new Headers(init?.headers);
  if (token) {
    headers.set("Authorization", `Bearer ${token}`);
  }
  return fetch(input, {
    ...init,
    credentials: init?.credentials ?? (bearerOnly ? "omit" : "include"),
    headers,
  });
}
